import React, {useState,useEffect} from 'react'
import Script from 'react-load-script'
import axios from 'axios';
import globals from 'react-global-configuration';
import { Container, Player} from './styles'

export const OnAir = (props) => {


    const _URL_REST = globals.get('_URL_REST')
    const [listSettings, setSettings] = useState(false);
    const fetchSettings = async () => {
        const result = await axios(
            `${_URL_REST}/getsettings/${props.idevento}`,
        );
        setSettings(result.data[0])
    };

    useEffect(() => {
        fetchSettings();
    },[]);

    if(listSettings === false){return (<div></div>)}
    return (
    <Container>
                <Player id={listSettings.idplayer}>
                    
                </Player>
                <Script
                url={listSettings.player}
                />
          
    </Container> 
    )
}